import useSWR from "swr";

export const useSupport = () => {
  const { data, mutate, error } = useSWR("/support");

  const loading = !data && !error;

  return { data, loading, error, mutate };
};
